import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import { GiphyGif } from "../types/giphy";
import styles from "./GifCard.module.css";
interface GifCardProps {
  gif: GiphyGif;
  onCopy: (url: string) => void;
}
export default React.memo(function GifCard(t0) {
  const $ = _c(16);
  const {
    gif,
    onCopy
  } = t0;
  let t1;
  if ($[0] !== gif.url || $[1] !== onCopy) {
    t1 = async () => {
      try {
        await navigator.clipboard.writeText(gif.url);
        onCopy(gif.url);
      } catch {
        const textArea = document.createElement("textarea");
        textArea.value = gif.url;
        textArea.style.position = "fixed";
        textArea.style.left = "-999px";
        textArea.style.top = "-999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand("copy");
          onCopy(gif.url);
        } catch {}
        document.body.removeChild(textArea);
      }
    };
    $[0] = gif.url;
    $[1] = onCopy;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  const videoSrc = gif.images.fixed_height.mp4 || gif.images.original.mp4;
  const posterSrc = gif.images.fixed_height.url;
  const gifTitle = gif.title || "Animated GIF";
  const videoWidth = parseInt(gif.images.fixed_height.width) || 480;
  const videoHeight = parseInt(gif.images.fixed_height.height) || 270;
  let t2;
  if ($[3] !== handleClick) {
    t2 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        handleClick();
      }
    };
    $[3] = handleClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleKeyDown = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.overlay}><span className={styles.overlayText}>Copy GIF</span></div>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== gifTitle || $[7] !== posterSrc || $[8] !== videoHeight || $[9] !== videoSrc || $[10] !== videoWidth) {
    t4 = videoSrc ? <video className={styles.media} src={videoSrc} poster={posterSrc} width={videoWidth} height={videoHeight} autoPlay={true} loop={true} muted={true} playsInline={true} preload="metadata" title={gifTitle} /> : <Image className={styles.media} src={posterSrc} alt={gifTitle} width={videoWidth} height={videoHeight} sizes="(max-width: 480px) 100vw, (max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw" style={{
      objectFit: "cover"
    }} priority={false} />;
    $[6] = gifTitle;
    $[7] = posterSrc;
    $[8] = videoHeight;
    $[9] = videoSrc;
    $[10] = videoWidth;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== handleClick || $[13] !== handleKeyDown || $[14] !== t4) {
    t5 = <div className={styles.card} onClick={handleClick} onKeyDown={handleKeyDown} role="button" tabIndex={0}>{t3}{t4}</div>;
    $[12] = handleClick;
    $[13] = handleKeyDown;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
});